import { InteractionTypes } from '@/entities/interaction';
import { InteractionList } from '@/widgets/interaction-list';

export default function TrustAcceptedPage() {
  return (
    <InteractionList
      type={InteractionTypes.TRUST_ACCEPTED}
      direction="bidirectional"
      title="Demandes de contact acceptées"
      emptyMessage="Aucune demande de contact acceptée pour le moment."
    />
  );
}
